import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteExtraVereinbarungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteExtraVereinbarungCommandService],
  exports: []
})
export class DeleteExtraVereinbarungCommandServiceModule { }
